<template>
    <div>
        <Form ref="applicationForm" :model="application" :rules="applicationRules" inline :label-width="120"
              class="form-common">
            <FormItem label="开始日期" prop="startDate">
                <DatePicker type="date" v-model="application.startDate" placeholder="开始日期"
                            format="yyyy-MM-dd"
                            @on-change="onStartDateChange"
                            style="width: 200px"></DatePicker>
            </FormItem>
            <FormItem label="结束日期" prop="endDate">
                <DatePicker type="date" v-model="application.endDate" placeholder="结束日期"
                            format="yyyy-MM-dd"
                            @on-change="onEndDateChange"
                            style="width: 200px"></DatePicker>
            </FormItem>
            <br/>
            <FormItem label="业务员名称" prop="yewuyuan">
                <Input v-model="application.yewuyuan" placeholder="业务员"></Input>
            </FormItem>
            <FormItem label="经销商" prop="cusName">
                <CusInput v-model="application.cusCode" @change="changeCusCode"
                          :name.sync="application.cusName"/>
            </FormItem>
            <br/>
            <FormItem class="btn-groups">
                <Button type="primary" @click="handleSubmit">查询</Button>
                <ExportButton api="report/getxiaoshouListDao" :disabled="exportDisabled" :params="exportParams">导出
                </ExportButton>
            </FormItem>
        </Form>
        <CTable border :columns="columns" :data="queryData" :total="total" :current="application.page" @change="change"
                :showPage="true" :row-class-name="rowClassName" height="500"/>

    </div>
</template>

<script>
    import CTable from '@/components/CTable'
    import BtnEvent from '@/components/BtnEvent'
    import {timeFormat, amountFormat, repalceGetParamsByObj} from '@/plugin/tool'
    import {auditStatusList, auditList} from '@/plugin/enum'
    import CusInput from "../../components/CusInput/CusInputView";
    import ExportButton from "../../components/ExportButton";

    let startColumns = [
       {
            fixed: 'left',
            title: '经销商',
            key: 'cusName',
            align: 'center',
            width: 140
        },
        {
            fixed: 'left',
            title: '业务员',
            key: 'yewuyuan',
            align: 'center',
            width: 140
        }, {
            title: '流通',
            key: 'liutong',
            align: 'center',
            width: 140,

        }, {
            title: '新品',
            key: 'xinpin',
            align: 'center',
            width: 140,
        }, {
            title: '全品',
            key: 'quanpin',
            align: 'center',
            width: 140,
        }
    ]
    let endColumns = [
        {
            title: '小计',
            align: 'center',
            key: 'xiaoji',
            width: 140,
        },
        {
            title: 'KA进场费',
            align: 'center',
            key: 'kaJinchang',
            width: 140,
        },
        {
            title: '进场费',
            key: 'jinchang',
            align: 'center',
            width: 140,
        },
        {
            title: '合计',
            key: 'heji',
            align: 'center',
            width: 140,
        },
        {
            title: '费比',
            key: 'feibi',
            align: 'center',
            width: 140,
        },
        {
            title: '费比(不含流通)',
            key: 'noliuFeibi',
            align: 'center',
            width: 140,
        },
        {
            title: '累计费用比列(不含进场、流通)',
            key: 'leiFeibi',
            align: 'center',
            width: 140,
        }
    ]

    export default {
        name: 'SalesExpenseRatio',
        mixins: [BtnEvent],
        components: {
            ExportButton,
            CusInput,
            CTable
        },
        data() {
            return {
                date: [],
                vdate: [],//用于选择审核通过日期
                cusList: [],
                application: {
                    page: 1,
                    pageSize: 10,
                    startDate: null,
                    endDate: null,
                    yewuyuan: null,
                    cusCode: null,
                    cusName: null
                },
                applicationRules: {
                    startDate: [
                        {required: true, type: 'string', message: '请输入开始时间', trigger: 'change'}
                    ],
                    endDate: [
                        {required: true, type: 'string', message: '请输入结束时间', trigger: 'change'}
                    ],
                },
                spList: auditList,
                total: 0,
                queryData: [], // 表格数据
                columns: [],
            }
        },
        computed: {
            exportParams() {
                return this.application
            },
            exportDisabled() {
                return !this.application.startDate || this.application.startDate.length === 0 || !this.application.endDate || this.application.endDate === 0
            }
        },
        created() {
        },
        methods: {
            changeCusCode(val) {

            },
            handleCusSuccess(cus) {
                this.application.cusName = cus.cusName
            },
            queryCus(value) {
                this.$fetch('SysCus/getCodeName', {
                    cusName: value
                }).then(res => {
                    this.cusList = res.data.list
                })
            },
            handleSubmit() { // 查询表单校验
                this.$refs.applicationForm.validate((valid) => {
                    if (valid) {
                        this.application.page = 1
                        this.queryTableData()
                    }
                })
            },
            queryTableData() { // 查询表格
                this.$fetch('report/getxiaoshouList', this.application).then(res => {
                    this.queryData = res.data.list
                    this.total = res.data.total
                    var tou = res.data.tou;
                    let columns = [];

                    _.forEach(tou, item => {
                        columns.push(
                            {
                                title: item,
                                key: item,
                                width: 140,
                                align: 'center',
                            }
                        )
                    })
                    this.columns = this.takeColumns(columns)
                })
            },
            takeColumns(columns) {
                return [
                    ...startColumns,
                    ...columns,
                    ...endColumns
                ]

            },
            change(index) {
                this.application.page = index
                this.queryTableData()
            },
            handleClickExport() {
                //点击了导出按钮
                window.location.href = window.location.origin + `/api/report/getxiaoshouListDao?` + repalceGetParamsByObj(this.application)
            },
            onEndDateChange(val) {
                this.application.endDate = timeFormat(val, 'date')
            },
            onStartDateChange(val) {
                this.application.startDate = timeFormat(val, 'date')
            },
            rowClassName(row, index) {
                if (row.yewuyuan === '小计') {
                    return 'demo-table-info-row';
                } else if (row.yewuyuan === '总计') {
                    return 'demo-table-error-row';
                } else if (row.yewuyuan === '合计') {
                    return 'demo-table-heji-row'
                }
                return '';
            },
        }
    }
</script>
